import PlaningToolRoot from '../PlaningToolRoot'
import { MItem } from '../Menu'
import { Box } from '@mui/material'
import NewsworthyModule from './NewsworthyModule'
import SalesPotentialChart from './SalesPotentialChart'
import { SalesChartMode } from '../../../DTO/GLItemsDTO'
import mainservice from '../../../services/MainService'

export default function DashboardDemo() {
  function openChart() {
    mainservice.navTo([
      ['view', 'spMarketingChart'],
      ['status', 'all'],
      ['chartMode', 'company' as SalesChartMode],
    ])
  }

  return (
    <PlaningToolRoot
      standalone
      menuItem={MItem.dashboardDemo}
      mainContentClass="DashboardDemo flex flex-column"
    >
      <div className="contentHeader">
        <h2>Dashboard Demo</h2>
      </div>
      <Box
        sx={{
          padding: 2,
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
          gap: 2,
          alignItems: 'start',
        }}
      >
        <NewsworthyModule />
        <SalesPotentialChart
          mode="company"
          variant="teaser"
          onOpenFull={openChart}
        />
      </Box>
    </PlaningToolRoot>
  )
}
